(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/disabled-team-result/assets/javascripts/disabled-team-result.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/disabled-team-result/assets/javascripts/disabled-team-result.js');
"use strict";

const {
  ReactIcon
} = svs.ui;
const DisabledTeamResult = () => React.createElement("div", {
  className: "disabled-team-result"
}, React.createElement(ReactIcon, {
  icon: "information",
  size: "600"
}), React.createElement("p", {
  className: "padding-top"
}, "Just nu kan vi inte visa resultat f\xF6r lagt\xE4vlingen."));
setGlobal('svs.components.marketplaceCompetition.disabledTeamResult.DisabledTeamResult', DisabledTeamResult);

 })(window);